import styled from "styled-components";

export const SPACING_WIDE = "wide";
export const SPACING_NARROW = "narrow";

const resolveIndicatorSize = ({ $isActive, $spacing }) => {
  const size = $spacing === SPACING_WIDE ? ($isActive ? "18px" : "12px") : $isActive ? "15px" : "8px";
  return `
    width: ${size};
    height: ${size};
  `;
};

const Container = styled.ol`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
`;

const DotButton = styled.button`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ $spacing }) => ($spacing === SPACING_WIDE ? 34 : 26)}px;
  height: ${({ $spacing }) => ($spacing === SPACING_WIDE ? 34 : 26)}px;
  @media (pointer: coarse) {
    width: ${({ $spacing }) => ($spacing === SPACING_WIDE ? 44 : 26)}px;
    height: ${({ $spacing }) => ($spacing === SPACING_WIDE ? 44 : 26)}px;
  }
`;

const Indicator = styled.div`
  opacity: ${({ $isActive }) => ($isActive ? 1 : 0.2)};
  background-color: ${({ color }) => color};
  border-radius: 50%;
  transition: all 0.2s ease-in-out;
  ${resolveIndicatorSize};
`;

/**
 * @param {object} props - props
 * @param props.id - the id of the page
 * @param props.isActive - whether the page is the current page
 * @param [props.ariaLabel] - the aria label for the page indicator, defaults to `${index + 1}`}
 * @param props.onClick - the callback to set the active page
 * @param props.color - color of the dots
 * @param props.spacing - spacing between dots
 */
const Dot = ({ id, ariaLabel, onClick, isActive, color, spacing = SPACING_WIDE }) => (
  <li>
    <DotButton id={`dot-${id}`} aria-label={ariaLabel} aria-current={isActive} onClick={onClick} $spacing={spacing}>
      <Indicator color={color} $isActive={isActive} $spacing={spacing} />
    </DotButton>
  </li>
);

export const PaginationDots = ({ pages, currentPageId, color, spacing = SPACING_WIDE }) => {
  if (!pages?.length) {
    return null;
  }
  return (
    <Container>
      {pages.map(({ id, ariaLabel, onClick }, index) => (
        <Dot
          key={id}
          id={id}
          ariaLabel={ariaLabel || `${index + 1}`}
          isActive={id === currentPageId}
          onClick={onClick}
          color={color}
          spacing={spacing}
        />
      ))}
    </Container>
  );
};
